(() => {
  const data = document.getElementById('QeydoLegalRoutes');
  if (!data) return;
  let routes;
  try { routes = JSON.parse(data.textContent); } catch { return; }
  let care = null;
  try { care = JSON.parse(document.getElementById('QeydoCareCommerce')?.textContent || 'null'); } catch {}
  const carePaths = new Set(care?.productPaths || []);
  const careVariants = new Set((care?.variantIds || []).map(String));
  const update = anchor => {
    const value = anchor.getAttribute('href');
    if (!value || value[0] === '#' || /^(mailto:|tel:|javascript:)/i.test(value)) return;
    let url;
    try { url = new URL(value, location.origin); } catch { return; }
    if (url.hostname.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '')) return;
    const path = url.pathname.replace(/\/$/, '');
    if (care?.infoUrl && carePaths.has(path)) { anchor.setAttribute('href', care.infoUrl); return; }
    const destination = routes[path];
    if (destination) anchor.setAttribute('href', destination + url.search + url.hash);
  };
  const scan = root => {
    if (root.matches?.('a[href]')) update(root);
    root.querySelectorAll?.('a[href]').forEach(update);
  };
  scan(document);
  // Standalone service forms go to the explanation; lock forms still add the Care+ option as a bundle.
  const guardStandaloneCare = event => {
    let root;
    if (event.type === 'submit') root = event.target;
    else {
      const button = event.target.closest?.('button[type="submit"], button[name="add"]');
      if (!button) return;
      root = button.form || button.closest('product-form');
    }
    const id = root?.querySelector('[name="id"]')?.value;
    if (!id || !careVariants.has(String(id)) || !care?.infoUrl) return;
    event.preventDefault(); event.stopImmediatePropagation();
    window.location.assign(care.infoUrl);
  };
  document.addEventListener('submit', guardStandaloneCare, true);
  document.addEventListener('click', guardStandaloneCare, true);
  // Observe added content only: updating an href cannot trigger a scan loop.
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) scan(node);
  }))).observe(document.body, {childList: true, subtree: true});
})();
